const DOCK_TOP_BAND_HEIGHT = 48;

export default DOCK_TOP_BAND_HEIGHT;
